<template>
  <b-row
    class="align-items-center border-r5 p-2 pointer"
    style="border: 1px dashed #28a745; background-color: #eee; max-width: 450px"
    @click="$refs.modal.toggleOpen()"
  >
    <b-col cols="10">Importe todos os seus produtos de uma única vez</b-col>
    <b-col class="text-right">
      <i class="fas fa-cloud-upload-alt fs-30 text-success"></i>
    </b-col>

    <modal ref="modal" />
  </b-row>
</template>

<script>
import Modal from './Modal.vue';

export default {
  name: 'UploadProductsSpreadsheet',
  components: {
    Modal,
  },
};
</script>